import React, {ReactNode} from 'react';
import ResponsiveAppBar from "../header/header";

interface layoutComponent {
    children: ReactNode
}

export const LayoutMain = ({children}: layoutComponent) => {
    return (
        <>
            <ResponsiveAppBar></ResponsiveAppBar>
            <main>{children}</main>
        </>
    )
}
